import { Component, OnInit } from '@angular/core';
import { Redirection } from 'common/redirection';
import { ActivatedRoute } from '@angular/router';
import { ArticlesApi, ProductionsApi, UsersApi } from 'api';
import { Article } from 'models';
import { AppConfig, Shell } from '@tytapp/common';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'tyt-spot-jump',
  templateUrl: './spot-jump.component.html',
  styleUrls: ['./spot-jump.component.scss']
})
export class SpotJumpComponent implements OnInit {

  constructor(
    private redirection : Redirection,
    private route : ActivatedRoute,
    private articlesApi : ArticlesApi,
    private productionsApi : ProductionsApi,
    private appConfig : AppConfig,
    private usersApi : UsersApi,
    private shell : Shell
  ) { }

  article : Article;

  async ngOnInit() {
    let observer = combineLatest(this.route.params, this.route.queryParams, (params, queries) => ({ params, queries }));
    observer.subscribe(async data => {
      let params = data.params;
      let queries = data.queries;

      let enabled = await this.appConfig.featureEnabled('apps.web.allow_spot_jump');
      if (!enabled) {
        this.redirection.go(`/`);
        return;
      }
      
      let identifier = params.id;
      let response : string = <string> await this.usersApi.resolveSpot(identifier).toPromise();

      if (!response) {
        await this.shell.showDialog('message', 'The video, podcast, or live stream you commented on is not currently available. Please try again later or contact support@tytnetwork.com');
        this.redirection.go('/');
        return;
      }
       
      let queryString = Object.keys(queries).map(key => `${key}=${encodeURIComponent(queries[key])}`).join('&');
      this.redirection.go(`${response}?comments&${queryString}`);
    })
  }

  async goHome() {
    this.redirection.go('/');
  }
}
